import { c as _c } from "react/compiler-runtime";
import { Typography } from '@mui/material';
import { Provider, type FileSearchRecord } from '@repo/api-gw-sdk';
import { Base64 } from 'js-base64';
import { TextLink } from '@/components/shared/textLink';
import { useRoles } from '@/contexts/useRoles';

// Google Workspace results deep-link into the dedicated Workspace explorer, which
// keys off the resourceId path segment; the ?file= param opens the file's parent.
export const buildFileHref = (entity: FileSearchRecord) => entity.cloudProvider === Provider.GoogleWorkspace ? `/saas-inventory/google-workspace/${encodeURIComponent(entity.resourceId)}?file=${encodeURIComponent(Base64.encode(entity.path))}` : `/explorer/${entity.resourceId}?file=${Base64.encode(entity.path)}`;
export const PathCell = t0 => {
  const $ = _c(4);
  const {
    entity
  } = t0;
  const {
    isAuthorized
  } = useRoles();
  const displayPath = entity.displayPath || entity.path;
  let t1;
  if ($[0] !== displayPath || $[1] !== entity || $[2] !== isAuthorized) {
    t1 = entity.path && <TextLink disabled={!isAuthorized("read:files")} href={buildFileHref(entity)}><Typography sx={{
        color: "inherit"
      }}>{displayPath}</Typography></TextLink>;
    $[0] = displayPath;
    $[1] = entity;
    $[2] = isAuthorized;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};